module.exports = __webpack_public_path__ + "a768e7de/img/product-icon-grey.b248963c.svg";